module.exports = __webpack_public_path__ + "img/9_26@2x.0c4b9c8d.png";